import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogComponent, DialogConfigInterface} from '../../../../shared/components';

@Component({
    selector: 'app-reset-password-result',
    templateUrl: './reset-password-result.component.html',
    styleUrls: ['./reset-password-result.component.scss']
})
export class ResetPasswordResultComponent extends DialogComponent<ResetPasswordResultComponent> {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            title: string,
            config: DialogConfigInterface
        },
        public dialogRef: MatDialogRef<ResetPasswordResultComponent>,
    ) {
        super(dialogRef);

        this.config = data.config;
    }
}
